import React from 'react';
import Table from '../../../../../Table';
import slugify from 'slugify';

/**
 * Render a vertical list of rows
 *
 * @param {Array} rows list of rows each with a list of React field components
 *
 */
const ValueEditorView = ({ rows }) => {

    const columns = [
        {
            propertyName: 'name',
            renderHeader: () => 'Property',
            renderCell: ({ item }) => item.name,
        },
        {
            propertyName: 'component',
            renderHeader: () => 'Value',
            renderCell: ({ item }) => item.component,
        },
    ];

    const keyGenerator = item => item.key;
    const rowClassName = item => `row-${slugify(item.name, { lower: true })}`;

    return (
        <div className="panel-group" id="accordion">
            {rows.map((row, index) => (
                <div className="panel panel-info" key={row.key}>
                    <div className="panel-heading" data-toggle="collapse" data-parent="#accordion" data-target={`#${row.key}`}>
                        <div className="panel-title accordion-toggle">
                            {`${index}: ${row.typeName}`}
                            <span className="pull-right">{row.deleteButton.component}</span>
                        </div>
                    </div>
                    <div id={row.key} className="panel-collapse collapse in">
                        <div className="panel-body">
                            <Table
                                items={row.fields}
                                columns={columns}
                                className="table table-striped table-bordered content-object"
                                keyGenerator={keyGenerator}
                                rowClassName={rowClassName}
                            />
                        </div>
                    </div>
                </div>
            ))
            }
        </div>
    );
};

export default ValueEditorView;
